import React from 'react'

import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import CircularProgress from '@mui/material/CircularProgress'
import Typography from '@mui/material/Typography'
import { GameType } from 'constants/enums/GameTypeEnum'
import { brainstormText } from 'content/brainstormText'

import { styles } from './PromptBox.styles'
import { PromptBoxData } from './PromptBoxGameData'

export type Props = {
	contentText: string
	'data-testid'?: string
	gameTypeEnum?: GameType
	hidePromptContainerStyle?: boolean
	loading?: boolean
	scrollable?: boolean
}

export const TEST_ID = 'prompt-box-'

const PromptBox = ({
	contentText = brainstormText.slotMachine.generateScenario,
	loading = false,
	hidePromptContainerStyle,
	gameTypeEnum,
	...props
}: Props) => {
	const gameId = gameTypeEnum?.value || 1
	const promptGameData = PromptBoxData[gameId]
	return (
		<Box
			data-testid={props['data-testid'] ?? 'prompt-container'}
			sx={{
				...(hidePromptContainerStyle
					? {}
					: styles.container(props.scrollable === true)),
				cursor: 'pointer',
			}}
			{...props}
		>
			<Card sx={styles.card} variant="outlined">
				<CardContent sx={styles.cardContentReset}>
					<Box
						data-testid="prompt-content-container"
						sx={{
							...styles.container(true, gameTypeEnum),
							background: promptGameData.background,
						}}
					>
						{loading ? (
							<CircularProgress
								sx={styles.circularProgressIcon}
							/>
						) : (
							<Typography sx={styles.contentText} variant="body1">
								{contentText}
							</Typography>
						)}
					</Box>
				</CardContent>
			</Card>
		</Box>
	)
}

export default PromptBox
